import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import AppRoutes from './AppRoutes';
import AuthRoutes from './AuthRoutes';
import { auth, refreshToken } from './firebase-init';
import Loading from './components/UI/loading';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import UdlChatbot from './components/UdlChatbot/UdlChatbot';
import Cookies from 'universal-cookie';
export const AuthContext = React.createContext(null);

export default () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const cookies = new Cookies();

  useEffect(() => {
    refreshToken();
    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user) {
        const userClaims = await user.getIdTokenResult();
        if (!userClaims.claims.role || (userClaims.claims.role && userClaims.claims.role === 'STUDENT')) {
          setAuthenticatedUser(user);
          setIsAuthenticated(true);
        }
      } else {
        setAuthenticatedUser(null);
        setIsAuthenticated(false);
      }
    });
    
    // Cleanup function
    return () => {
      unsubscribe();
    };
  }, []);
  useEffect(() => {
    if (isAuthenticated && window.location.pathname.includes('login')) {
      window.location.replace('/');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    document.documentElement.lang = cookies.get('language') || 'ar';
  }, [cookies]);

  return (
    <AuthContext.Provider
      value={{
        user: authenticatedUser,
        isAuth: isAuthenticated,
      }}
    >
      <Router>
        <ScrollToTop />
        {isAuthenticated === true ? (
          <AppRoutes auth_user={authenticatedUser} />
        ) : isAuthenticated === false ? (
          <AuthRoutes />
        ) : (
          <Loading />
        )}
        {isAuthenticated !== null ? <UdlChatbot /> : null}
      </Router>
    </AuthContext.Provider>
  );
};
